// oxlint-disable-next-line no-unused-vars
import React, { use, useMemo, type PropsWithChildren } from 'react'
import { AudienceService } from './api'
import { useAuthedFetch } from '@/hooks/useAuthedFetch'
import { genericMemo } from '@/components/genericMemo'

const defaultApi = new AudienceService('localhost:8000', fetch)

export const AudienceServiceContext = React.createContext(defaultApi)

interface AudienceServiceProviderProps {
    apiUrl: string
}

export const AudienceServiceProvider: React.FC<
    PropsWithChildren<AudienceServiceProviderProps>
> = genericMemo(({ apiUrl, children }) => {
    const authedFetch = useAuthedFetch()
    const newApi = useMemo(
        () => new AudienceService(apiUrl, authedFetch),
        [apiUrl, authedFetch]
    )

    return (
        <AudienceServiceContext value={newApi}>
            {children}
        </AudienceServiceContext>
    )
})

export const useAudienceService = (): AudienceService =>
    use(AudienceServiceContext)
